import React, { useCallback, useEffect, useState} from "react";
import {
  Typography,
  Box,
  TextField,
  Autocomplete,
  Tabs,
  Tab,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import { useHistory, useLocation } from "react-router";
import { ROUTE_PATHS } from "src/routes";
import { useStoreContext } from "src/store/context";
import { useAddAlert } from "src/store/actions";
import { LiveCatalogDetailTab } from "./catalog_detail_tab/LiveCatalogDetailTab";
import { AddLiveCatalog } from "../modals/AddLiveCatalog";
import { deleteModalStyle, modalStyle } from "src/shared/Styles/Styles";
import CloseIcon from '@mui/icons-material/Close';
import { alertMessages } from "src/constants";
import { getLiveCatalogCall } from "src/apis/getCatalogCalls";
import { DeleteCatalog } from "../modals/DeleteCatalog";
import { checkAdminRole } from "src/store/common";
import { AuditCatalog } from "./catalog_audits/AuditCatalog";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box >{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function LiveFuelCatalogDetail({tab}) {
  const history = useHistory();
  const location = useLocation();
  const [state, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);

  const [tabValue, setTabValue] = useState(tab);
  const [liveFuelCatalog, setLiveFuelCatalog] = useState<any>(null);
  const [routes, setRoutes ] = useState<string[]>([]);
  const [searchedLFCatatlog, setSearchedLFCatalog] = useState<any>(null);
  const [searchOptions, setSearchOptions] = useState<any[]>([]);

  const [openLiveModal, setOpenLiveModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [createUpdateLiveSuccess, setCreateUpdateLiveSuccess] = useState<boolean>(false);
  const [deleteFuelCatalogSuccess, setDeleteFuelCatalogSuccess] = useState<boolean>(false);
  const [editLiveFuel, setEditLiveFuel] = useState<string>('');

  /**
   * Make the api call for live catalog details
   */
  const liveFuelCatalogDetailsCallback = useCallback((request: any, search?:boolean) => {
    (async () => {
      try {
        const liveFuelCatalogResults: any = await getLiveCatalogCall(request, addAlert);
        if(liveFuelCatalogResults.data.length > 0) {
          if(search) {
            setSearchOptions(liveFuelCatalogResults.data);
          } else {
            setLiveFuelCatalog(liveFuelCatalogResults.data[0]);
          }
        } else {
          search? setSearchOptions([]) : setLiveFuelCatalog(null);
        }
        setCreateUpdateLiveSuccess(false);
      } catch(error) {
        search? setSearchedLFCatalog([]):setLiveFuelCatalog(null);
        setCreateUpdateLiveSuccess(false);
        addAlert({
          id: '',
          message: alertMessages.retrieveCatalog,
          type: 'error-info',
          icon: 'fa-exclamation-triangle'
        });
      }
    })();
  }, [addAlert]);

  const clickViewAllLiveCatalogs = useCallback(()=>{
    history.push({
      pathname: `${ROUTE_PATHS.table}${ROUTE_PATHS.liveTab}`,
      state: {...liveFuelCatalog, page: 0, perPage: 10}
    })
  }, [history, liveFuelCatalog]);

  /**
   * Initialization of live catalog details
   */
  useEffect(()=>{
    if(location?.state){
      const thisLiveFuelCatalog:any = location.state;
      if(thisLiveFuelCatalog.from){
        setSearchedLFCatalog(thisLiveFuelCatalog)
      }
      setLiveFuelCatalog(thisLiveFuelCatalog);
      setEditLiveFuel(thisLiveFuelCatalog?.gsiParameterCatalogId)
      setRoutes([`${ROUTE_PATHS.table}${ROUTE_PATHS.liveTab}/detail/${thisLiveFuelCatalog?.gsiParameterCatalogId}`,
        `${ROUTE_PATHS.table}${ROUTE_PATHS.liveTab}/audit/${thisLiveFuelCatalog?.gsiParameterCatalogId}`,
      ]);
    }
    else{
      const stringArray = decodeURIComponent(location.pathname).split("/");
      const catalogId = stringArray[stringArray?.length-1];
      const request = {
        id: Number(catalogId),
        sortBy: 'catalog_name',
        sortOrder: 'ASC'
      }
      liveFuelCatalogDetailsCallback(request);
      setRoutes([`${ROUTE_PATHS.table}${ROUTE_PATHS.liveTab}/detail/${catalogId}`, 
      `${ROUTE_PATHS.table}${ROUTE_PATHS.liveTab}/audit/${catalogId}`,
      ]);
    }
  },[location?.pathname, location.state, liveFuelCatalogDetailsCallback])

  /**
   * Populate the search bar
   */
  useEffect(() => {
    const requestSearch = {
        sortBy: 'catalog_name',
        sortOrder: 'ASC',
    }
    liveFuelCatalogDetailsCallback(requestSearch, true);
  }, [liveFuelCatalogDetailsCallback]);

  
  /*successful save or update or delete*/
  useEffect(() => {
    if(createUpdateLiveSuccess){
      const request = {
        id: Number(liveFuelCatalog.gsiParameterCatalogId),
        sortBy: 'catalog_name',
        sortOrder: 'asc',
      }
      liveFuelCatalogDetailsCallback(request);
      //call for search options
      const requestSearch = {
        id: null,
        catalogName: null,
        sortBy: 'catalog_name',
        sortOrder: 'asc'
      }
      liveFuelCatalogDetailsCallback(requestSearch, true);
    } else if (deleteFuelCatalogSuccess) {
      clickViewAllLiveCatalogs();
    }
  }, [liveFuelCatalogDetailsCallback, createUpdateLiveSuccess, deleteFuelCatalogSuccess, liveFuelCatalog, clickViewAllLiveCatalogs]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    history.push({
      pathname: `${routes[newValue]}`,
      state: {...liveFuelCatalog}
    });
  };

  const handleCloseLiveModal = (_event: any, reason: any) => {
    if (reason && reason === "backdropClick") {
      setOpenLiveModal(false);
    }
    setOpenLiveModal(false);
    setEditLiveFuel('');
  }

  const handleDeleteCatalog = () => {
    setOpenDeleteModal(true);
  }
  
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  }

  const onLiveFuelCatalogSearch = (e:React.SyntheticEvent<Element, Event>, incomingVal: any) =>{
    history.push(
      { pathname: `${ROUTE_PATHS.table}${ROUTE_PATHS.liveTab}/detail/${incomingVal?.gsiParameterCatalogId}`, state: { ...incomingVal, from: 'search' } }
    )
  }

  return (
    <Box>
      <Modal //Modal to open edit/create live fuel
        className="smooth-scrollbar"
        open={openLiveModal}
        onClose={handleCloseLiveModal}
      >
      
        <div>
          <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenLiveModal(false) }}>
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding" >
            {
              <AddLiveCatalog setOpen={setOpenLiveModal} setCreateUpdateLiveSuccess={setCreateUpdateLiveSuccess} editLiveFuelCatalog={editLiveFuel}/>
            }
          </Box>
        </div>
      </Modal>
      <Modal //Modal to delete catalog
        className="smooth-scrollbar"
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
      >
        <div style={{ height: '100%' }}>
          <IconButton aria-label='close' style={{ left: '64%', top:'23.5%', position: 'absolute', cursor: 'pointer' }} onClick={(e)=>handleCloseDeleteModal()} >
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={deleteModalStyle} className="smooth-scrollbar removePadding" >
            { state.user && checkAdminRole(state.user) &&
              <DeleteCatalog setOpenDeleteModal={setOpenDeleteModal} setDeleteFuelCatalogSuccess={setDeleteFuelCatalogSuccess} deleteCatalogId={liveFuelCatalog?.gsiParameterCatalogId} catalogName={liveFuelCatalog?.catalogName} catalogCategory={'Live'}/>
            }
          </Box>
        </div>
      </Modal>

      {/* Toolbar */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 2,
        }}
      >
        {/* Left Section */}
        <Box sx={{display: 'flex', flexDirection:'column'}}>
          <Typography variant="h5">
            <span style={{marginRight: '1rem', textTransform:'capitalize'}}>{liveFuelCatalog?.catalogName}</span> 
            <Button variant="contained" style={{marginLeft:'1rem'}} onClick={()=> {setOpenLiveModal(true)}}>Edit Catalog</Button>
            { liveFuelCatalog?.gsiParameterCatalogId !== 1 &&
              <Button variant="contained" color='error' style={{marginLeft:'1rem'}} onClick={()=>handleDeleteCatalog()}>Delete Catalog</Button>
            }
          </Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", flexDirection: "column", marginRight: '1rem',alignItems: "flex-end", width: '25vw' }}>
          <div className="searchStationsDownloadPage">
            {/* Search Icons */}
            <i className="fas fa-search"/>
            <Autocomplete
              id="liveFuelDetailCatalogSearch"
              clearOnEscape
              freeSolo
              noOptionsText={
                <div className='no-results'>
                    <div>No results match your search criteria.</div>
                </div>
              }
              options={searchOptions}
              getOptionLabel={(option) => `${option.catalogName}`}
              aria-label="liveFuelDetailCatalogSearch"
              value={searchedLFCatatlog}
              onChange={(event, newValue) => onLiveFuelCatalogSearch(event, newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Search Live Fuel Catalogs...'}
                  placeholder="Search Live Fuel Catalogs..."
                />
              )}
            />
          </div>
          <Box mt={1}>
            <Button variant='text' onClick={clickViewAllLiveCatalogs} className="font-sans-sm text-bold" style={{ color: "#1675e0", textTransform:'capitalize' }}>
              View All Live Fuel Catalogs
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Tabs Section */}
      <Box sx={{ width: "100%", marginTop: 3 }}>
        <Box sx={{ borderColor: "divider" }}>
        {/* Tabs Section */}
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="custom tabs example"
            className="tabcatalog"
          >
            <Tab label="Details" {...a11yProps(0)} />
            <Tab label="Audit Logs" {...a11yProps(1)} />

          </Tabs>
        </Box>
        {/* Tab Panels */}
        <CustomTabPanel value={tabValue} index={0}>
          <div style={{backgroundColor: '#dddddd', height: '60vh'}}>
            <LiveCatalogDetailTab liveCatalog={liveFuelCatalog} />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <div style={{backgroundColor: '#eeeeee', height: '100%'}}>
          <AuditCatalog catalogType={'LiveFuel'}/>
          </div>
        </CustomTabPanel>
      </Box>

    </Box>
  );
}

export default LiveFuelCatalogDetail;